<template>
<div class="createOreditPatient" v-if="patient">
  <div class="marsk" v-if="showType==='read' && !isEdit"></div>
  <div class="head">
    <div class="title">新增患者</div>
    <div class="doBox">
      <el-button size="mini" v-if="(showType !=='read' || isEdit) && isShowSave" class="save" type="primary" plain @click="save">保存</el-button>
      <el-button size="mini" v-if="showType !=='read' || isEdit" class="save" type="info" plain @click="close">取消</el-button>
      <div class="edit" v-if="showType==='read' && !isEdit" @click="isEdit = true">编辑</div>
      <div class="cancel" v-if="showType==='read' && !isEdit" @click="close">取消</div>
    </div>
  </div>
  <el-form inline :model="patient" align="left" :rules="patientRules" ref="patientRules" :validate-on-rule-change="false">
    <div class="row">
      <el-form-item  prop="name" :show-message="false">
        <el-input placeholder="姓名" style="width: 100px" v-model="patient.name"></el-input>
      </el-form-item>
      <el-form-item  prop="gender" :show-message="false">
        <el-select style="width: 50px" v-model="patient.gender" placeholder="请选择">
          <el-option label="男" value="NAN"></el-option>
          <el-option label="女" value="NV"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="ageYear"  :show-message="false">
        <div class="formItem">
          <el-input @input="handleAgeInput('years')"
                    @blur="adjustAge"  style="width: 40px;" v-model="patient.ageYear"></el-input>
          <div class="label"><span class="must">*</span>岁</div>
        </div>
      </el-form-item>

      <el-form-item prop="ageMonth" :show-message="false">
        <div class="formItem">
          <el-input  @input="handleAgeInput('months')"
                     @blur="adjustAge"  style="width: 40px;" v-model="patient.ageMonth"></el-input>
          <div class="label"><span class="must">*</span>月</div>
        </div>
      </el-form-item>

      <el-form-item prop="ageDays" :show-message="false">
        <div class="formItem">
          <el-input @input="handleAgeInput('days')"
                    @blur="adjustAge"  style="width: 40px;" v-model="patient.ageDays"></el-input>
          <div class="label"><span class="must">*</span>日</div>
        </div>
      </el-form-item>

    </div>
    <div class="row birthday">
      <el-form-item label="身份证" prop="idNumber" :show-message="false">
        <el-input placeholder="身份证" style="width: 150px" v-model="patient.idNumber"></el-input>
      </el-form-item>
      <el-form-item label="生日" prop="idNumber" :show-message="false">
        <el-date-picker
            @change="changeBirthDay"
            style="width: 155px;"
            :picker-options="{disabledDate: (time) => time.getTime() > Date.now()}"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            v-model="patient.birthday"
            type="date"
            placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
    </div>
    <div class="row">

      <el-form-item label-width="50px" label="民族" prop="nationnality" :show-message="false">
        <el-select style="width: 150px" v-model="patient.nationnality" placeholder="请选择">
          <el-option
              v-for="item in nationnalityList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-left: 5px;margin-right: 0">
        <el-select style="width: 60px;margin-left: 20px" value="86" placeholder="请选择">
          <el-option label="+86" value="86"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="phoneNumber" :show-message="false">
        <el-input placeholder="手机号" style="width: 105px" v-model="patient.phoneNumber"></el-input>
      </el-form-item>
    </div>
    <div class="row">
      <el-form-item style="margin-left: 5px;margin-right: 0">
        <el-select style="width: 60px;margin-left: 20px" value="86" placeholder="请选择">
          <el-option label="+86" value="86"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="emergencyPhone" :show-message="false">
        <el-input style="width: 310px" placeholder="紧急联系电话" v-model="patient.emergencyPhone"></el-input>
      </el-form-item>
    </div>
    <div class="row">
      <span class="must" style="position: absolute;top: 10px;left: -7px">*</span>
      <el-form-item label="现居住地" label-width="64px"  prop="districtCode" :show-message="false">
        <el-cascader
            placeholder="现居住地"
            style="width: 334px"
            v-model="cityCode"
            :options="cityList"
            @change="changeCity"></el-cascader>
      </el-form-item>
    </div>
    <div class="row">
      <span class="must" style="position: absolute;top: 10px;left: 5px">*</span>
      <el-form-item  label="职业" label-width="50px"  prop="job" :show-message="false">
        <el-select style="width: 345px" clearable efault-first-option allow-create filterable v-model="patient.job" placeholder="职业">
          <el-option
              v-for="option in careerList"
              :key="option.id"
              :label="option.label"
              :value="option.label">
            <span style="float: left">{{ option.label }}</span>
          </el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item  label=" " label-width="20px"  prop="address" :show-message="false">-->
<!--        <el-input style="width: 345px;position: relative;left: 30px" placeholder="详细地址" v-model="patient.address"></el-input>-->
<!--      </el-form-item>-->
    </div>
    <div class="row">
      <span class="must" style="position: absolute;top: 10px;left: 5px">*</span>
      <el-form-item label="身高" style="margin-left: 11px" prop="height" :show-message="false">
        <el-input placeholder="身高" style="width: 125px" v-model="patient.height"></el-input>
      </el-form-item>
      <div class="label">CM</div>
      <span class="must" style="position: absolute;top: 10px;right: 48%">*</span>
      <el-form-item label="体重" style="margin-left: 11px"  prop="weight" :show-message="false">
        <el-input placeholder="体重" style="width: 125px" v-model="patient.weight"></el-input>
      </el-form-item>
      <div class="label">KG</div>
    </div>
    <div class="row">
      <el-form-item style="margin-left: 11px" label="婚姻" prop="marriage" :show-message="false">
        <el-select  style="width: 133px" v-model="patient.marriage" placeholder="请选择">
          <el-option
              v-for="item in marriageTypeList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
    </div>
  </el-form>
</div>
</template>

<script>
import {get, post} from "@/api/api";
import {careerList} from "@/views/outpatientDoctorWorkstation/outpatientService/staticData.js";
export default {
  name: "index",
  props:['type', 'userInfoData','showType'],
  computed:{
    isShowSave () {
      return this.$hasPermission('/outpatientDoctor/patient/save');
    },
  },
  data() {
    return {
      cityCode: [],
      careerList,
      isEdit: false,
      isUpdatingFromAge: false, // 添加标志变量，标记是否正在从年龄更新生日
      nationnalityList:[], //民族字典
      marriageTypeList:[], //婚姻状态字典
      jobTypeList:[], //职业字典
      cityList:[],
      patient:{

      },
      patientRules:{
        name:[
          {required: true, message: '不能为空',trigger:'blur'},
        ],
        districtCode:[
          {required: true, message: '请选择现居住地',trigger:'submit'}
        ],
        gender:[
          {required: true, message: '请选择性别',trigger:'blur'},
        ],
        job:[
          {required: true, message: '请输入职业',trigger:'blur'},
        ],
        weight:[
          {required: true, message: '请输入体重',trigger:'blur'},
        ],
        height:[
          {required: true, message: '请输入身高',trigger:'blur'},
        ],
        ageYear:[
          {validator: (rule, value, callback) => {
            if (!this.patient.ageYear && !this.patient.ageMonth && !this.patient.ageDays) {
              callback(new Error('年龄信息不能全部为空'));
            } else {
              callback();
            }
          }},
        ],
        ageMonth:[
          {validator: (rule, value, callback) => {
            if (!this.patient.ageYear && !this.patient.ageMonth && !this.patient.ageDays) {
              callback(new Error('年龄信息不能全部为空'));
            } else {
              callback();
            }
          }},
        ],
        ageDays:[
          {validator: (rule, value, callback) => {
            if (!this.patient.ageYear && !this.patient.ageMonth && !this.patient.ageDays) {
              callback(new Error('年龄信息不能全部为空'));
            } else {
              callback();
            }
          }},
        ],
        phoneNumber:[
          {required: false, message: '不能为空'},
          {pattern: /^1[3-9]\d{9}$/, message: '格式错误'},
          {validator: (rule, value, callback) => {
              if (!this.patient.phoneNumber && !this.patient.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话必填一项'));
              } else {
                callback();
              }
              if ((this.patient.phoneNumber && this.patient.emergencyPhone) && this.patient.phoneNumber  === this.patient.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话不能相同'));
              } else {
                callback();
              }
            }}
        ],
        emergencyPhone:[
          {required: false, message: '不能为空'},
          {pattern: /^1[3-9]\d{9}$/, message: '格式错误'},
          {validator: (rule, value, callback) => {
              console.log(value)
              if (!this.patient.phoneNumber && !this.patient.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话必填一项'));
              } else {
                callback();
              }
              if ((this.patient.phoneNumber && this.patient.emergencyPhone) && this.patient.phoneNumber  === this.patient.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话不能相同'));
              } else {
                callback();
              }
            }},
        ],
      }
    }
  },
  watch: {
    showType (val) {
      if (val === 'read') {

      }
    },
    '$store.state.nowPatientInfo':{
      handler (newValue,oldValue) {
        if (newValue && JSON.stringify(newValue) === JSON.stringify(oldValue)) {
          return
        }
        this.patient = JSON.parse(JSON.stringify(newValue))
        if (this.patient.districtCode) {
          this.cityCode = [this.patient.provinceCode,this.patient.cityCode,this.patient.districtCode]
        }
        this.$nextTick(()=>{
          this.$refs.patientRules.clearValidate()
        })
      },
      deep:true,
      immediate:true
    },
  },
  mounted() {
    this.getList()
    this.getCity()
    },
  methods: {
    // 安全处理输入的方法
    handleAgeInput(fieldSuffix) {
      const fieldName = `age${fieldSuffix}`;

      // 确保字段存在（防御性编程）
      if (!this.patient.hasOwnProperty(fieldName)) {
        this.$set(this.patient, fieldName, '');
      }

      // 安全处理输入值
      const currentValue = this.patient[fieldName] || '';
      const newValue = currentValue.toString().replace(/[^\d]/g, '');

      // 更新值，限制数字长度
      this.patient[fieldName] = newValue.substring(0, 3);
    },
    changeCity (val) {
      this.patient.provinceCode = val[0]
      this.patient.cityCode = val[1]
      this.patient.districtCode = val[2]
      console.log(this.patient)
    },
    getCity () {
      get('/common/levelMetadata/getMetadataList').then(res=>{
        this.cityList = transformData(res.data.data.AreaCode)
        /**
         * 转换数据结构
         * @param {Array} data - 原始数据数组
         * @returns {Array} 转换后的新数组
         */
        function transformData(data) {
          if (!Array.isArray(data)) {
            return [];
          }

          return data.map(item => {
            const newItem = {
              label: item.name,
              value: item.code,
            };

            // 递归处理子项
            if (item.childList && item.childList.length > 0) {
              newItem.children = transformData(item.childList);
            } else {
              newItem.children = null;
            }

            // 保留其他原始属性（如id）
            for (const key in item) {
              if (key !== 'name' && key !== 'code' && key !== 'childList') {
                newItem[key] = item[key];
              }
            }

            return newItem;
          });
        }
      })
    },
    getList () {
      get('/common/constantItem/getConstantList').then(res=>{
        console.log('ressss', res.data.data)
        this.nationnalityList = res.data.data.Nationnality
        this.marriageTypeList = res.data.data.MarriageType
        this.jobTypeList = res.data.data.JobType
      })
    },
    // 调整年龄值的方法（解决进位/退位问题）
    adjustAge() {
      // 处理空值，转换为0
      const years = parseInt(this.patient.ageYear || 0);
      const months = parseInt(this.patient.ageMonth || 0);
      const days = parseInt(this.patient.ageDays || 0);

      // 处理天数进位/退位
      let totalMonths = months + Math.floor(days / 30);
      let remainingDays = days % 30;

      // 处理负天数（从月借位）
      if (remainingDays < 0) {
        totalMonths -= 1;
        remainingDays += 30;
      }

      // 处理月份进位/退位
      let totalYears = years + Math.floor(totalMonths / 12);
      let remainingMonths = totalMonths % 12;

      // 处理负月数（从年借位）
      if (remainingMonths < 0) {
        totalYears -= 1;
        remainingMonths += 12;
      }

      // 确保最小值
      const finalYears = Math.max(0, totalYears);
      const finalMonths = Math.max(0, remainingMonths);
      const finalDays = Math.max(0, remainingDays);

      // 更新视图（空值时显示空而不是0）
      this.$set(this.patient, 'ageYear', finalYears === 0 ? '' : finalYears);
      this.$set(this.patient, 'ageMonth', finalMonths === 0 ? '' : finalMonths);
      this.$set(this.patient, 'ageDays', finalDays === 0 ? '' : finalDays);
      this.$set(this.patient,'birthday',this.$calculateBirthDate(this.patient.ageYear,this.patient.ageMonth,this.patient.ageDays))
    },
    checkAge () {
      let age = this.adjustDate(this.patient.ageYear,this.patient.ageMonth,this.patient.ageDays)
      this.patient.ageYear =  age.years
      this.patient.ageMonth =  age.months
      this.patient.ageDays =  age.days
      // this.patient.birthday = this.$calculateBirthDate(this.patient.ageYear,this.patient.ageMonth,this.patient.ageDays)
    },
    // 生日
    // 修改生日方法（添加空值处理）
    changeBirthDay() {
      if (!this.patient.birthday) {
        // 清空年龄字段
        this.$set(this.patient, 'ageYear', '');
        this.$set(this.patient, 'ageMonth', '');
        this.$set(this.patient, 'ageDays', '');
        return;
      }

      const age = this.$calculateAge(this.patient.birthday) || {};

      // 处理计算结果中的空值
      this.$set(this.patient, 'ageYear', age.years === undefined ? '' : age.years);
      this.$set(this.patient, 'ageMonth', age.months === undefined ? '' : age.months);
      this.$set(this.patient, 'ageDays', age.days === undefined ? '' : age.days);
    },
    close () {
      this.isEdit = false
      this.$emit('close')
    },
    save () {

      this.$refs.patientRules.validate(v=>{
        if (v){
          if (!this.patient.phoneNumber && !this.patient.emergencyPhone) {
            return this.$message.error("手机号与紧急联系电话必填一项")
          }
          if ((this.patient.phoneNumber && this.patient.emergencyPhone) && this.patient.phoneNumber  === this.patient.emergencyPhone) {
            return this.$message.error("手机号与紧急联系电话不能相同")
          }
          post('/outpatientDoctor/patient/save', this.patient).then(res=>{
            console.log(res)
            if (res.data.code === 200) {
              this.$message.success('保存成功！')
              this.patient.caseNumber = res.data.data
              this.$store.commit('updatePatientByDraftId', this.patient)
              this.$store.commit('setNowPatientInfo',this.patient)
              this.$emit('refresh-list')
              this.close()
            }
          }).catch(err=>{
            console.log(err)
          })
        }
      })

    }
  }
}
</script>

<style lang="less" scoped>
.createOreditPatient{
  width: 100%;
  position: relative;
  .marsk{
    top: 25px;
    left: -10px;
    width: 424px;
    height: 245px;
    position: absolute;
    z-index: 999;
    background-color: rgba(51, 50, 50,.1);
    opacity: .23;
    border-radius: 4px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
      font-weight: 700;
    }
    .doBox{
      display: flex;
      align-items: center;
      .save{
        height: 20px;
        display: flex;
        align-items: center;
      }
      .cancel{
        color: rgba(0,0,0,.3);
        cursor: pointer;
        &:hover{
          color: rgba(0,0,0,.5);
        }
      }
      .edit{
        color: #409eff;
        cursor: pointer;
        margin-right: 15px;
        &:hover{
          color: #0f75f1;
        }
      }
    }
  }
  .birthday{
    /deep/ .el-input__inner {
      padding-left: 30px !important;
    }
  }
  .row {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    position: relative;
    .must{
      color: red;
      font-size: 15px;
    }

    .formItem {
      display: flex;
      align-items: center;
    }
  }
}

/deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus, .el-message-box__input input.invalid, .el-message-box__input input.invalid:focus{
  border: 1px solid #f93 !important;
  background-color: #fef7e9 !important;
}
/deep/.el-form-item__error {
  font-size: 12px;
  position: absolute;
  top: -59%;
  left: 5%;
  background: #f93;
  padding: 7px;
  border-radius: 3px;
  color: #fff;
  display: none;
}
/deep/.el-form-item{
  margin: 0;
}
/deep/ .el-input__inner {
  height: 26px;
  border: 1px solid  rgba(0,0,0,.1) !important;
  text-align: left !important;
  font-size: 13px !important;
  padding: 0 5px;
}
/deep/ .el-form--inline .el-form-item{
  margin-right: 5px;
}
/deep/ .el-form-item__label {
  font-size: 13px;
}
/deep/  .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  content: none !important;
}
</style>
